import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Brain, Heart } from 'lucide-react';
import { CalorieRing } from './CalorieRing';
import { MacroRings } from './MacroRings';
import { useMealStore } from '../../store/mealStore';

export function NutritionOverview() {
  const { todaysStats } = useMealStore();

  return (
    <div className="space-y-6">
      {/* Calorie and Macro Overview */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="theme-card p-6"
        >
          <CalorieRing
            consumed={todaysStats.calories}
            burned={650}
            goal={2500}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="theme-card p-6"
        >
          <MacroRings
            protein={{ current: todaysStats.protein, goal: 180 }}
            carbs={{ current: todaysStats.carbs, goal: 250 }}
            fat={{ current: todaysStats.fat, goal: 80 }}
          />
        </motion.div>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-3 gap-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="theme-card p-4 relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
          <div className="relative">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              <Activity className="w-4 h-4" />
              <span>Net Calories</span>
            </div>
            <div className="text-2xl font-bold">
              {todaysStats.calories - 650}
            </div>
            <div className="text-xs text-muted-foreground mt-1">
              After activity
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="theme-card p-4 relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
          <div className="relative">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              <Brain className="w-4 h-4" />
              <span>Protein Ratio</span>
            </div>
            <div className="text-2xl font-bold">
              {Math.round((todaysStats.protein * 4) / todaysStats.calories * 100 || 0)}%
            </div>
            <div className="text-xs text-muted-foreground mt-1">
              of total calories
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="theme-card p-4 relative overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-50" />
          <div className="relative">
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              <Heart className="w-4 h-4" />
              <span>Meals Logged</span>
            </div>
            <div className="text-2xl font-bold">
              {Object.keys(todaysStats).length}
            </div>
            <div className="text-xs text-muted-foreground mt-1">
              today
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}